export default function (Alpine) {
    Alpine.store('formSuccess', {
        open: false,

        show() {
            this.open = true;
        },

        close() {
            this.open = false;
        },
    });
}
